import * as React from 'react';

function SvgSpringMinus8(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.685 24.637v6.69l-10.052 6.281 20.103 12.561-20.103 12.562 20.103 12.561-20.103 12.562 20.103 12.561-20.103 12.561 20.103 12.562-20.103 12.561 20.103 12.562-20.103 12.561 20.103 12.561-10.051 6.281v6.69"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M20.185 235.68v2.587l-17.402 3.494 20.1 4.035-20.1 4.036 20.103 4.036-20.103 4.036 20.1 4.037-20.1 4.035 20.103 4.036-20.103 4.036 20.1 4.035-20.1 4.036 20.103 4.037-2.7.542v5.538h5v-2.586l17.401-3.494-20.103-4.037 20.103-4.034-20.105-4.037 20.105-4.036-20.105-4.036 20.105-4.037-20.103-4.035 20.103-4.036-20.105-4.036 20.105-4.036-20.103-4.035 2.701-.543v-5.538h-5z"
        fill={props.springcolor}
      />
      <path
        d="M34.218 0h-23v23h23V0zM34.218 292h-23v23h23v-23z"
        fill="#5BAD92"
      />
    </svg>
  );
}

export default SvgSpringMinus8;
